import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-381">
      <div className="max-w-5xl mx-auto" data-id="element-382">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-383">
          Lo que <span className="text-[#00B4D8]" data-id="element-384">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-385">
          <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-6" data-id="element-386">
            <h3 className="text-[#00B4D8] text-xl font-black mb-2" data-id="element-387">
              🎾 LOS 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-388">
              Para profesores de pádel de todos los niveles
            </p>
            <div className="space-y-4" data-id="element-389">
              <div className="flex items-center gap-3 text-white" data-id="element-390">
                <span className="text-xl" data-id="element-391">🟢</span>
                <div className="flex-1" data-id="element-392">
                  <span className="font-bold" data-id="element-393">
                    Tomo 1 — Iniciación (8va/7ma)
                  </span>
                  <span className="text-gray-300" data-id="element-394">
                    {' '}
                    40 clases · Fundamentos y primeros golpes
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-395">
                <span className="text-xl" data-id="element-396">🟡</span>
                <div className="flex-1" data-id="element-397">
                  <span className="font-bold" data-id="element-398">
                    Tomo 2 — Principiante (6ta/5ta)
                  </span>
                  <span className="text-gray-300" data-id="element-399">
                    {' '}
                    40 clases · Paredes, volea y juego en pareja
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-400">
                <span className="text-xl" data-id="element-401">🟠</span>
                <div className="flex-1" data-id="element-402">
                  <span className="font-bold" data-id="element-403">
                    Tomo 3 — Intermedio (4ta/3ra)
                  </span>
                  <span className="text-gray-300" data-id="element-404">
                    {' '}
                    40 clases · Víbora, remate y táctica de partido
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-405">
                <span className="text-xl" data-id="element-406">🔴</span>
                <div className="flex-1" data-id="element-407">
                  <span className="font-bold" data-id="element-408">Tomo 4 — Avanzado (2da/1ra)</span>
                  <span className="text-gray-300" data-id="element-409">
                    {' '}
                    40 clases · Golpes pro, mental y torneos
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-410">
                <span className="text-xl" data-id="element-411">🟣</span>
                <div className="flex-1" data-id="element-412">
                  <span className="font-bold" data-id="element-413">
                    Tomo 5 — Drills & Canastos Pro
                  </span>
                  <span className="text-gray-300" data-id="element-414">
                    {' '}
                    60 drills · 1 a 4 alumnos · Todos los niveles
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-415">
                <span className="text-xl" data-id="element-416">⭐</span>
                <div className="flex-1" data-id="element-417">
                  <span className="font-bold" data-id="element-418">
                    Tomo 6 — Planificación Anual & Testeo
                  </span>
                  <span className="text-gray-300" data-id="element-419">
                    {' '}
                    12 meses planificados · Fichas de testeo · Gestión
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00B4D8]/5 border border-[#00B4D8]/30 rounded-2xl p-8 text-center" data-id="element-420">
          <h3 className="text-[#00B4D8] text-xl font-black mb-6" data-id="element-421">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-422">
            <div className="flex items-start gap-2 text-left" data-id="element-423">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-424">✅</span>
              <span className="text-white text-sm" data-id="element-425">
                Planificación anual lista para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-426">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-427">✅</span>
              <span className="text-white text-sm" data-id="element-428">
                40 clases con objetivo, desarrollo y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-429">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-430">✅</span>
              <span className="text-white text-sm" data-id="element-431">
                Sistema "Scan & Play" (leés en 3 min antes de entrar)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-432">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-433">✅</span>
              <span className="text-white text-sm" data-id="element-434">
                Evaluaciones + rúbricas (escala 1-5)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-435">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-436">✅</span>
              <span className="text-white text-sm" data-id="element-437">
                Fichas de seguimiento por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-438">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-439">✅</span>
              <span className="text-white text-sm" data-id="element-440">
                Variantes para nivel más fácil y más difícil
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-441">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-442">✅</span>
              <span className="text-white text-sm" data-id="element-443">
                Material original ProfePack®
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-444">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-445">✅</span>
              <span className="text-white text-sm" data-id="element-446">
                100% adaptado al sistema de categorías argentino
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}